import { DeviceDataPointId } from "@tether-nz/device-data-points";
import { SeriesType } from "./SeriesType";

export const SeriesTypeDataPointMapping: Partial<Record<SeriesType, DeviceDataPointId>> = {
  [SeriesType.GeneratedEnergy]: DeviceDataPointId.GeneratedkWh,
  [SeriesType.ImportedEnergy]: DeviceDataPointId.ImportedkWh,
  [SeriesType.ExportedEnergy]: DeviceDataPointId.ExportedkWh,
  [SeriesType.MaxCurrent]: DeviceDataPointId.MaxCurrent,
  [SeriesType.MinCurrent]: DeviceDataPointId.MinCurrent,
  [SeriesType.AverageCurrent]: DeviceDataPointId.AverageCurrent,
  [SeriesType.Voltage]: DeviceDataPointId.Voltage,
  [SeriesType.PowerFactor]: DeviceDataPointId.PowerFactor,
  [SeriesType.Power]: DeviceDataPointId.TotalkWh,
}

export const DataPointSeriesTypeMapping: Partial<Record<DeviceDataPointId, SeriesType>> = Object.entries(SeriesTypeDataPointMapping)
  .reduce((acc, [seriesTypeString, dataPoint]) => {

    acc[dataPoint] = seriesTypeString as SeriesType;
    return acc;

  }, {} as Partial<Record<DeviceDataPointId, SeriesType>>);